<template>
    <v-container v-resize="onResize">
        <statistical-header :title="title"></statistical-header>
        <loader v-if="loading" />
        <template v-if="!loading">
            <statistical-member-or-senator-selector :value="selectedMpOrSenator" @input="selectedMpOrSenator = $event" />
            <br/>

            <v-layout row wrap align-center justify-space-between>
                <v-btn-toggle v-model="chartType" class="transparent handbook_toggleButton" :mandatory="true">
                    <v-tooltip top :disabled="this.$vuetify.breakpoint.name !== 'md'">
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" class="handbook_button" :value="'parties'"><span class="long-button-text chamberButton">States by Party</span></v-btn>
                        </template>
                        <span>States by party</span>
                    </v-tooltip>
                    <v-tooltip top :disabled="this.$vuetify.breakpoint.name !== 'md'">
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" class="handbook_button" :value="'states'"><span class="long-button-text chamberButton">Parties by state</span></v-btn>
                        </template>
                        <span>Parties by state</span>
                    </v-tooltip>
                </v-btn-toggle>
            </v-layout>

            <br/>
            <chart v-show="chartType === 'parties'" :chartData="chartData"/>
            <chart v-show="chartType === 'states'" :chartData="chartDataStates"/>
            <br/>
         
            <div class="stats-table">
                 
                <v-data-table
                    :headers="headers" 
                    :items="items"
                    :rows-per-page-items="rowsPerPageItems"
                    :hide-actions="true"
                    :class="{ mobileDataTable: isMobile, 'elevation-1': true }"
                    :hide-headers="isMobile"
                    :loading="loading"
                    :custom-sort="customSort"
                    :disable-initial-sort="true">
                    <template v-slot:items="props">
                        <template v-if="isMobile">
                            <tr>
                                <td>
                                    <div class="flex-content">
                                        <div class="flex-item">
                                            <h3 class="pb-xs-1"><a @click="handleStateClick(props.item.StateId)">{{ props.item.State }}</a></h3>
                                        </div>
                                        <div class="flex-item" data-label="Parties">
                                            <div v-for="party in parties" :key="party.value">
                                                <span v-if="props.item.Parties.findIndex(p => p.PartyAbbrev === party.PartyAbbrev) !== -1">
                                                    <a @click="handleRecordClick(props.item.StateId, party.Party)">
                                                        <span v-if="party.PartyAbbrev !== 'Total'">{{ party.PartyAbbrev }}: {{ props.item.Parties.find(p => p.PartyAbbrev === party.PartyAbbrev).Count }}</span>
                                                        <span  class="font-weight-bold" v-if="party.PartyAbbrev == 'Total'">{{ party.PartyAbbrev }}: {{ props.item.Parties.find(p => p.PartyAbbrev === party.PartyAbbrev).Count }}</span>
                                                    </a>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </template>
                        <template v-if="!isMobile">
                            <td class="text-xs-left"><a @click="handleStateClick(props.item.StateId)">{{ props.item.State }}</a></td>
                            <td class="text-xs-left" v-for="party in parties" :key="party.value">
                                <span v-if="props.item.Parties.findIndex(p => p.PartyAbbrev === party.PartyAbbrev) !== -1">
                                    <a @click="handleRecordClick(props.item.StateId, party.Party)">{{ props.item.Parties.find(p => p.PartyAbbrev === party.PartyAbbrev).Count }}</a>
                                </span>
                            </td>
                        </template>
                    </template>
                    <template v-slot:footer>
                    </template>
                </v-data-table>
            </div>
            <br/>
            <v-layout row wrap>
                <v-flex xs12>
                    <v-btn class="csvButton" @click="exportCsv" v-on:keyup.enter="exportCsv" color="primary">
                        <v-icon aria-hidden="true" :class="csvDownloadClass">{{csvDownloadIcon}}</v-icon>
                        <span>&nbsp;Download as CSV</span>
                    </v-btn>
                </v-flex>
            </v-layout>
        
        </template>
    </v-container>
</template>
<script>
import Loader from '@/components/Loader.vue';
import StatisticalHeader from './StatisticalHeader.vue';
import StatisticalMemberOrSenatorSelector from './StatisticalMemberOrSenatorSelector.vue';
import Chart from './Chart.vue';
import axios from 'axios';
window.Handbook = window.Handbook || {}
const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
axios.defaults.baseURL = apiUri;

export default {
    created() {
        this.initialiseItems();
    },
    components: {
        Loader,
        Chart,
        StatisticalHeader,
        StatisticalMemberOrSenatorSelector
    },
    methods: {
        onResize() {
            if (window.innerWidth < 769){
                this.isMobile = true;
            }
            else{
                this.isMobile = false;
            }
        },
        changeSort(column) {
            if (this.PAGINATION.sortBy === column) {
                this.PAGINATION.descending = !this.PAGINATION.descending
            } 
            else {
                this.PAGINATION.sortBy = column
                this.PAGINATION.descending = false
            }
        },
        initialiseItems() {
            this.loading = true;
            const parliamentarianType = this.selectedMpOrSenator.length == 0 || this.selectedMpOrSenator.length == 2 ?
                '' : this.selectedMpOrSenator[0];
            const url = `StatisticalInformation/Composition?parliamentariantype=${parliamentarianType}`;
            axios.get(`api/${url}`)
                .then(response => {
                    this.items = response.data.Rows;
                    this.parties = response.data.Parties;
                    this.partiesExcludingTotal = response.data.Parties.filter(p => p.PartyAbbrev !== 'Total');
                    this.headers = [{
                        text: 'State',
                        value: 'State'
                    }, ...response.data.Parties.map(p => ({ text: p.PartyAbbrev, value: p.PartyId || p.PartyAbbrev }))]
                    this.loading = false;
                });
        },
        handleStateClick(stateId) {
            const query = {
                "logicalOperator":"all",
                "children":[
                    {"type":"query-builder-rule", "query":{"rule":"inCurrentParliament","selectedOperand":"In current Parliament","value":"Yes"}}
                ]};
            if (stateId) {
                query.children.push({"type":"query-builder-rule","query":{"rule":"state","selectedOperator":"of","selectedOperand":"State","value":stateId}});
            }

            if (this.selectedMpOrSenator.length == 1) {
                const selected = this.selectedMpOrSenator[0];
                switch (selected) {
                    case 'senator':
                        query.children.push({"type":"query-builder-rule","query":{"rule":"mpOrSenator","selectedOperand":"Member or Senator","value":"senator"}});
                        break;
                    case 'mp':
                        query.children.push({"type":"query-builder-rule","query":{"rule":"mpOrSenator","selectedOperand":"Member or Senator","value":"member"}});
                }
            }
            
            localStorage.query = JSON.stringify(query);    
            this.$router.push('/AdvancedSearch');
        },
        handleRecordClick(stateId, partyId) {
            const query = {
                "logicalOperator":"all",
                "children":[
                    {"type":"query-builder-rule", "query":{"rule":"inCurrentParliament","selectedOperand":"In current Parliament","value":"Yes"}}
                ]};

            if (stateId) {
                query.children.push({"type":"query-builder-rule","query":{"rule":"state","selectedOperator":"of","selectedOperand":"State","value":stateId}});
            }

            if (partyId) {
                var partyVal = "[{\"field\":\"RefList1\",\"value\":[],\"simpleValue\":[],\"textValue\":\"" + partyId + "\",\"dateValue\":null,\"fieldType\":null}]";
                query.children.push({"type":"query-builder-rule","query":{"rule":"parties.represented.new","selectedOperator":"of","selectedOperand":"Parties represented", "value":partyVal }});
            }

            if (this.selectedMpOrSenator.length == 1) {
                const selected = this.selectedMpOrSenator[0];
                switch (selected) {
                    case 'senator':
                        query.children.push({"type":"query-builder-rule","query":{"rule":"mpOrSenator","selectedOperand":"Member or Senator","value":"senator"}});
                        break;
                    case 'mp':
                        query.children.push({"type":"query-builder-rule","query":{"rule":"mpOrSenator","selectedOperand":"Member or Senator","value":"member"}});
                }
            }

            localStorage.query = JSON.stringify(query);    
            this.$router.push('/AdvancedSearch');
        },
        customSort(items, index, isDesc) {
            items.sort((a, b) => {
                if (a.StateId === 0) {
                    return 1;
                }
                if (typeof index === "number" || index === 'Total') {
                    const partyA = a.Parties.find(p => index === 'Total' ? p.PartyId === null : p.PartyId === index);
                    const partyB = b.Parties.find(p => index === 'Total' ? p.PartyId === null : p.PartyId === index);
                    // for items, get party
                    // a is less than b is -1
                    // a is greater than b is 1
                    if (!isDesc) {
                        if (!partyA && !partyB) {
                            return 0;
                        }
                        if (!partyA) {
                            return -1
                        }
                        if (!partyB) {
                            return 1
                        }
                        return partyA.Count < partyB.Count ? -1 : 1;
                    } else {
                        if (!partyA && !partyB) {
                            return 0;
                        }
                        if (!partyA) {
                            return 1
                        }
                        if (!partyB) {
                            return -1
                        }
                        return partyB.Count < partyA.Count ? -1 : 1;
                    }
                } else {
                    if (!isDesc) {
                        return a[index] < b[index] ? -1 : 1;
                    } else {
                        return b[index] < a[index] ? -1 : 1;
                    }
                }
            });
            return items;
        },        
        filterMpOrSenator() {
            this.initialiseItems();
        },
        exportCsv: function () {
            this.csvDownloading = true;
            const records = this.items.sort((a, b) => a.$id < b.$id ? -1 : 1)
                .map(i => ({ State: i.State, ...i.Parties.reduce((ac,a) => ({...ac,[a.PartyAbbrev]:a.Count}),{}) }));
            let headers = this.headers.map(h => h.value);
            const filename = 'Party represenation by state';
            const comment = `Data current as of ${(new Date()).toLocaleDateString()}`;
            this.$store.dispatch('GETCSV', { DATA: records, HEADERS: headers, FILENAME: filename, COMMENT: comment })
                .catch(this.showError)
                .finally(() => this.csvDownloading = false);
        }
    }, 
    computed: {
        csvDownloadIcon() {
            return this.csvDownloading ? 'cached' : 'text_snippet';
        },
        csvDownloadClass() {
            let csvClass = 'mr-1';
            if (this.csvDownloading){
                csvClass = csvClass + ' loading'
            }
            return csvClass;
        },
        chartData() {
            return {
                chart: {
                    type: 'bar'
                },
                title: {
                    text: 'States by party representation—current Parliament'
                },
                xAxis: {
                    categories: this.items.filter(i => i.State !== 'Australia').map(i => i.State)
                },
                yAxis: {
                    title: {
                        text: 'States by party representation—current Parliament'
                    }
                },
                exporting: {
                    filename: 'States by party representation'
                },
                tooltip: {
                    pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b><br/>',
                },
                series: this.partiesExcludingTotal
                    .map(p => ({ 
                        name: p.PartyAbbrev, 
                        fullName: p.Party,
                        color: p.PartyColour,
                        data: this.items.filter(i => i.State !== 'Australia').map(i => i.Parties.findIndex(pa => pa.PartyAbbrev === p.PartyAbbrev) !== -1 
                        ? i.Parties.find(pa => pa.PartyAbbrev === p.PartyAbbrev).Count : 0 )}))
            }
        },
        chartDataStates() {
            const series = this
                .items
                .filter(i => i.State !== 'Australia')
                .map(i => ({
                    name: i.State,
                    data: this.partiesExcludingTotal
                        .map(p => i.Parties.findIndex(pa => pa.PartyAbbrev === p.PartyAbbrev) !== -1 ?
                        i.Parties.find(pa => pa.PartyAbbrev === p.PartyAbbrev).Count
                        : 0)
                }));
            return {
                chart: {
                    type: 'bar'
                },
                title: {
                    text: 'Party representation by state—current Parliament'
                },
                xAxis: {
                    categories: this.partiesExcludingTotal.map(p => p.PartyAbbrev)
                },
                exporting: {
                    filename: 'Party representation by state'
                },
                yAxis: {
                    title: {
                        text: 'Party representation by state—current Parliament'
                    }
                },
                series
            }
        }
    },
    watch: {
        selectedMpOrSenator: function () {
            this.initialiseItems();
        }
    },
    mounted() {
        this.onResize();
    },
    data() {
        return {
        isMobile: false,
        title: 'Party representation by state—current Parliament',
        headers: [],
        items: [],
        parties: [],
        partiesExcludingTotal: [],
        chartType: 'parties',
        search: '',
        loading: true,
        csvDownloading: false,
        selectedMpOrSenator: ['mp'],
        PAGINATION: {
            rowsPerPage: -1,
            sortBy: '',
            descending: false
        },
        rowsPerPageItems: [ {
            "text": "$vuetify.dataIterator.rowsPerPageAll",
            "value": -1
            }]
        }
    }
}
</script>
<style lang="stylus" scoped>
     @media screen and (max-width: 1420px) {
        .stats-table >>> table.v-table thead td:not(:nth-child(1)), 
        .stats-table >>> table.v-table tbody td:not(:nth-child(1)), 
        .stats-table >>> table.v-table thead th:not(:nth-child(1)), 
        .stats-table >>> table.v-table tbody th:not(:nth-child(1)), 
        .stats-table >>> table.v-table thead td:first-child, 
        .stats-table >>> table.v-table tbody td:first-child, 
        .stats-table >>> table.v-table thead th:first-child, 
        .stats-table >>> table.v-table tbody th:first-child,
        .stats-table >>> table.v-table thead th:first-child {
            padding: 0 14px !important;
        }

        .stats-table >>> th {
            white-space: break-spaces;
        }
    }

</style>